import { authSplitApi } from 'redux/helpers/slice.helpers';
import { THPDocResponse } from 'data/types/DocPacket.types';
import { TTenantAnimals } from 'data/types/Tenant.types';

export const commonApi = authSplitApi('commonApi', [], 'common').injectEndpoints(
  {
    endpoints: build => ({
      getTemplate: build.mutation<THPDocResponse, string>({
        query(docType) {
          return {
            url: `application-sample-template/search`,
            method: 'GET',
            params: { docType },
          };
        },
      }),
      getTenantAnimals: build.query<TTenantAnimals[], string>({
        query(tenantId) {
          return {
            url: `tenant/${tenantId}/animals`,
            method: 'GET',
          };
        },
      }),
    }),
    overrideExisting: false,
  },
);

export const { useGetTemplateMutation, useGetTenantAnimalsQuery } = commonApi;